import script from "./join.vue?vue&type=script&setup=true&lang=js"
export * from "./join.vue?vue&type=script&setup=true&lang=js"

import "./join.css?vue&type=style&index=0&id=02468839&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-zl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02468839"]])

export default __exports__